import { BASE_URL, requests } from "./base"

const ATTACH_INVOICES_ACCOUNT = `${BASE_URL}/admin/teacher/glance/attach`
const REGISTER_PARTNER = `https://api.glance.co.il/auth/register/partner`

interface AttachInvoicesAccountResponse {
  success: boolean
}

export type CompanyType = "MURSHE" | "COMPANY" | "PATOOR"

export interface RegisterPartnerRequest {
  // Required user fields
  email: string
  firstName: string
  lastName: string
  phoneNumber: string
  // Required company fields
  companyId: string
  companyName: string
  companyType: CompanyType
  // Optional fields
  companyEmail?: string
  companyTaxAmount?: number
  companyAddressId?: number
  companyLogoFileId?: number
  companySignatureFileId?: number
  resellerId?: number
}

interface RegisterPartnerResponse {
  success: boolean
  apiKey?: string
  error?: {
    code: "EMAIL_EXISTS_ERROR" | "COMPANY_EXISTS_ERROR" | "UNKNOWN_ERROR"
    message: string
  }
}

export const registerPartner = async (data: RegisterPartnerRequest) => {
  const res = await requests.post<RegisterPartnerResponse>(
    REGISTER_PARTNER,
    { ...data, resellerId: 1 }
  )
  return res
}
export const attachInvoicesAccount = async (
  apiKey: string,
  uid: number
) => {
  const res = await requests.post<AttachInvoicesAccountResponse>(
    `${ATTACH_INVOICES_ACCOUNT}`,
    { uid, apiKey }
  )
  return res
}
